export const suscription = {
  p1: `Gestisci i dettagli del tuo piano attuale ed esplora le opzioni per fare l’upgrade o cambiare il tuo abbonamento.`,
  p2: `Piano annuale`,
  p3: `Piano mensile`,
  p4: `Attivo fino al`,
  p5: `Per camera al mese`,
  p6: `Per alloggio al mese`,
  p7: `Numero di occupazione`,
  p8: `Per occupazione al mese`,
  p9: `Aggiorna abbonamento`,
  p10: `Servizi attivi`,
  p11: `Attivo`,
  p12: `Non attivo`,
  p13: `Invita i tuoi ospiti a fare il check-in tramite WhatsApp, programmandolo prima del loro arrivo in struttura.`,
  p14: `Recensioni`,
  p15: `Invita i tuoi ospiti a valutare la loro esperienza e a migliorare la reputazione della tua struttura con recensioni positive.`,
  p16: `Accesso remoto`,
  p17: `Registra e gestisci le camere dotate di serrature smart. Configura i codici di accesso da fornire agli ospiti.`,
  p18: `Verifica dell’identità`,
  p19: `Verifichiamo l’identità degli ospiti confrontando la foto del documento o del passaporto con un selfie in tempo reale.`,
  p20: `Gestisci abbonamento e metodi di pagamento`,
  p21: `Aggiungi o rimuovi carte secondo necessità`,
  p22: `Il tuo abbonamento attuale è gratuito`,
  p23: `Fai l’upgrade del tuo abbonamento per accedere alle funzionalità avanzate.`,
  p24: `Il tuo abbonamento gratuito scade tra`,
  p25: `giorno`,
  p26: `giorni`,
  p27: `Non perdere l’accesso alle funzionalità avanzate; fai subito l’upgrade del tuo abbonamento`,
  p28: `Personalizza il tuo piano con servizi aggiuntivi`,
  p29: `occupazione`,
  p30: `mese`,
  p31: `Recensioni`,
  p32: `Accesso remoto`,
  p33: `tenda`,
  p34: `villa`,
  p35: `Verifica dell’identità`,
  p36: `OCCUPAZIONE TOTALE`,
  p37: `L’occupazione totale si riferisce alla capacità massima di persone consentita in tutti i tuoi Appartamenti, ad esempio, (se selezioni 5 appartamenti, la tua occupazione totale può essere di 20 posti). Fornire l’occupazione totale ci aiuta a gestire il tuo abbonamento in modo accurato e a rispettare le normative sulla sicurezza.`,
  p38: `L’occupazione totale si riferisce alla capacità massima di persone consentita nella tua Villa, ad esempio, (se selezioni 5 appartamenti, la tua occupazione totale può essere di 20 posti). Fornire l’occupazione totale ci aiuta a gestire il tuo abbonamento in modo accurato e a rispettare le normative sulla sicurezza.`,
  p39: `L’occupazione totale si riferisce alla capacità massima di persone consentita nel tuo Hotel - Hostel, ad esempio, (se selezioni 5 appartamenti, la tua occupazione totale può essere di 20 posti). Fornire l’occupazione totale ci aiuta a gestire il tuo abbonamento in modo accurato e a rispettare le normative sulla sicurezza.`,
  p40: `L’occupazione totale si riferisce alla capacità massima di persone consentita nel tuo Camping, ad esempio, (se selezioni 5 appartamenti, la tua occupazione totale può essere di 20 posti). Fornire l’occupazione totale ci aiuta a gestire il tuo abbonamento in modo accurato e a rispettare le normative sulla sicurezza.`,
  p41: `Devi inserire l’occupazione totale delle tue strutture.`,
  p42: `WACheckin WhatsApp`,
  p43: `Il tuo WhatsApp Business`,
  p44: `per occupazione/mese`,
  p45: `per camera/mese`,
  p46: `Annuale`,
  p47: `Attiva abbonamento`,
  p48: `Aggiorna abbonamento`,
  p49: `Abbonamento selezionato`,
  p50: `Numero di`,
  p51: `camera`,
  p52: `alloggio`,
  p53: `Prezzo mensile per`,
  p54: `camere`,
  p55: `alloggi`,
  p56: `Numero di occupazione selezionato`,
  p57: `Prezzo mensile per`,
  p58: `occupazione`,
  p59: `Tipo di abbonamento`,
  p60: `Annuale`,
  p61: `Mensile`,
  p62: `Servizi aggiuntivi:`,
  p63: `Nessun servizio aggiunto`,
  p64: `Si consiglia di aggiungere il servizio WhatsApp`,
  p65: `Recensioni`,
  p66: `Totale da pagare`,
  p67: `Procedi con il pagamento`,
  p68: `Aggiorna abbonamento`,
  p69: "ChatBot",

  p70: `Abbonamento`,
  p71: `Attivo`,
  p72: `Servizi aggiuntivi opzionali`,

  p73: `Hai nuove strutture da gestire?`,

  p74: `Dettagli del tuo aggiornamento e dei nuovi servizi`,
  p75: `L’addebito per servizi o strutture aggiuntivi verrà applicato in modo proporzionale, tenendo conto dei giorni rimanenti del mese nel tuo abbonamento attuale.`,
  p76: `In questo modo paghi solo per il tempo di utilizzo effettivo fino al rinnovo del tuo piano.`,

  p77: `Strutture aggiunte`,
  p78: `Servizi aggiuntivi`,
  p79: `Accesso remoto`,
  p80: `ChatBot IA`,
  p81: `Prezzo`,
  p82: `Annuale`,
  p83: `Mensile`,
  p84: `Aggiorna abbonamento`,

  p85: `Strutture in abbonamento`,
  p86: `Servizi aggiuntivi`,
  p87: `Nessun servizio aggiuntivo sottoscritto`,
  p88: `ChatBot IA`,
  p89: `Accesso remoto`,

  p90: `Incluso nel piano`,

  p91: `Prezzo all’anno`,
  p92: `Prezzo al mese`,

  p93: `Stato`,
  p94: `Attivo`,
  p95: `Scade`,

  p96: `Registra e gestisci le camere dotate di serrature smart. Configura i codici di accesso che verranno forniti agli ospiti.`,

  p97: `ChatBot IA`,
  p98: `Aggiungi il servizio di chatbot basato sull’IA e automatizza le richieste dei tuoi ospiti in modo rapido ed efficiente.`,

  p99: `Sei sicuro di voler continuare con la procedura?`,
  p100: `Aggiorna abbonamento`,

  p101: ``,
  p102: ``,
  p103: ``,
  p104: ``,
  p105: ``,
  p106: ``,
  p107: ``,
  p108: ``,
  p109: ``,
  p110: ``,
  p111: ``,
  p112: ``,
  p113: ``,
  p114: ``,
  p115: ``,

};
